<template>
  <div id="login">
    <div class="login_logo">
      <div class="img">
        <img src="@/assets/img/logosvg.svg" />
      </div>
      <div class="title">{{$t('login.title')}}</div>
    </div>
    <div class="login">
      <div class="language">
        <languageTranslation></languageTranslation>
        <!-- <div class="flag">
          <img src="@/assets/img/flag.png" />
        </div>
        <div class="dow">
          <img src="@/assets/img/dow.png" />
        </div> -->
      </div>
      <div id="login_lo">
        <div class="title">{{$t('login.signIn')}}</div>
      </div>
      <div class="login_input">
        <div class="login_input_title">{{$t('login.email')}}</div>
        <input v-model="logins.account" :placeholder="$t('account.login_input_title')" />
      </div>
      <div class="login_input">
        <div class="login_input_title">{{ $t("Password") }}</div>
        <input
          v-model="logins.password"
          :placeholder="$t('Your Password')"
          :type="eye !== 1 ? 'text' : 'password'"
          :class="code ? '' : 'error'"
        />
        <img
          v-if="eye"
          @click="eyess()"
          src="@/assets/img/ege1.png"
          class="login_input_eye"
        />
        <img
          v-if="!eye"
          @click="eyess()"
          src="@/assets/img/ege.png"
          class="login_input_eye"
        />
      </div>
      <div class="Tips">
        {{ code ? "" : "Incorrect email or password" }}
      </div>
      <div @click="gologin()" class="loginButton">{{$t('login.signIn')}}</div>
      <router-link :to="{ name: 'Forgot' }" class="login_a"
        >{{$t('login.forgot')}}</router-link
      >
      <router-link :to="{ name: 'account' }" class="login_a"
        >{{$t('login.noAccount')}}
      </router-link>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      code: 1,
      logins: {
        account: '',
        password: ''
      },
      eye: 1,
      msg: ''
    }
  },
  mounted () {},
  methods: {
    gologin () {
      login(this.logins).then((adj) => {
        this.code = adj.code
        if (this.code === 1) {
          localStorage.setItem('avatar', adj.data.userinfo.avatar)
          localStorage.setItem('id', adj.data.userinfo.id)
          localStorage.setItem('nickname', adj.data.userinfo.nickname)
          localStorage.setItem('email', adj.data.userinfo.email)
          localStorage.setItem('username', adj.data.userinfo.username)
          localStorage.setItem('token', adj.data.userinfo.token)
          this.$router.push({ name: 'index' })
        }
      })
    },
    eyess () {
      this.eye = (this.eye + 1) % 2
      console.log(this.eye)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#login {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: url(./../assets/img/login.png);
  background-size: 100% auto;
  color: #fff;
}
.login_logo {
  position: absolute;
  top: 45%;
  right: 70%;
}
.login_logo .img,
.login_logo .img img {
  width: 170px;
}
.login_logo .title {
  font-size: 16px;
  line-height: 50px;
}
.login {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -300px 0 0;
  background: #fff;
  border-radius: 20px;
}
.login .language {
  position: absolute;
  right: 20px;
  top: 20px;
  /* width: 40px; */
  /* height: 20px; */
  overflow: hidden;
}
.login .language .flag {
  border-radius: 8px;
}
.login .language .dow,
.login .language .flag {
  width: 16px;
  height: 16px;
  overflow: hidden;
  float: left;
  position: relative;
  margin: 2px;
}
.login .language img {
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  left: 0;
}
#login_lo {
  width: 360px;
  margin: 0 auto;
  color: #000;
  text-align: left;
}
#login_lo .title {
  font-size: 32px;
  font-weight: 700;
  font-family: Noto Sans;
  margin: 60px 0 30px;
}
#login_lo .title2 {
  font-size: 24px;
  font-weight: 700;
  font-family: Noto Sans;
  line-height: 36px;
}
.login_input {
  width: 360px;
  margin: 0 auto;
  padding-bottom: 10px;
  text-align: left;
  position: relative;
}
.login_input .login_input_title {
  font-size: 14px;
  line-height: 30px;
  color: #000;
}
.login_input input {
  height: 48px;
  width: 358px;
  border-radius: 8px;
  border: 1px solid #d5d7db;
  text-indent: 1em;
  font-size: 14px;
  padding: 0;
}
.login_input input:focus {
  border: 1px solid #00eec3;
}
.login_input input.error {
  border: 1px solid #f54545;
}
.login_input_eye {
  position: absolute;
  bottom: 10px;
  right: 16px;
  width: 16px;
  height: 16px;
  bottom: 28px;
}
.loginButton {
  width: 360px;
  height: 50px;
  border-radius: 25px;
  background: #00eec3;
  font-size: 16px;
  font-weight: 700;
  color: #000927;
  line-height: 50px;
  margin: 0 auto 50px;
  -webkit-box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
  box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
}
.Tips {
  width: 360px;
  height: 16px;
  text-align: center;
  color: #f54545;
  font-size: 12px;
  margin: 0 auto 30px;
}
.login_a {
  font-size: 14px;
  text-align: center;
  color: #0080ff;
  display: block;
  margin-bottom: 24px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue